import React from 'react';
import { QModal, QModalHeader, QText, QModalBody, QModalActions, QButton } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';

type ResetPermissionModalProps = {
  resetPermissions: () => void;
  closeModal: () => void;
};

const ResetUserPermissionsModal = ({ closeModal, resetPermissions }: ResetPermissionModalProps) => {
  const { t } = useTranslation();
  const submitClick = () => {
    resetPermissions();
    closeModal();
  };

  return (
    <QModal onClose={closeModal} size="md" isOpen>
      <QModalHeader>
        <QText data-cy="heading">{t('modals.updatePermissions.title')}</QText>
      </QModalHeader>
      <QModalBody>
        <QText>{t('modals.updatePermissions.message')}</QText>
      </QModalBody>
      <QModalActions>
        <QButton data-cy="no-button" variant="outline" onClick={closeModal}>
          {t('modals.updatePermissions.noKeep')}
        </QButton>
        <QButton data-cy="yes-button" onClick={submitClick}>
          {t('modals.updatePermissions.yesUpdate')}
        </QButton>
      </QModalActions>
    </QModal>
  );
};

export default ResetUserPermissionsModal;
